const Address = ({ text }) => {
  return (
    <span className="w-full max-w-[150px] lg:max-w-none lg:w-[250px] text-bodyMobile md:text-bodyDesktop text-background font-chivoMono">
      {text}
    </span>
  )
}

export default Address
